import axios from "axios";
import React from "react";
import Chatbutton from '../components/chatbutton'
import '../styles/chatbutton.css'
import 'bootstrap/dist/css/bootstrap.css';
import AllusersButton from "../components/allusersButton";
import MyOrder from "../components/myorderbutton";
import Addproductbutton from "../components/addproductbutton";
const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
const token = localStorage.getItem("token");


export default class ProfileScreen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      posts: []
    }

    this.onFormSubmit = this.onFormSubmit.bind(this)
  }

  onFormSubmit(event) {
    event.preventDefault();
    localStorage.removeItem("token")
    localStorage.removeItem("loggedInUserID")
    localStorage.removeItem("type")
    window.location.replace("/");
  }


  componentDidMount() {
    axios.get(`https://shoppee-clone.herokuapp.com/user/${loggedInUserID}`)
      .then(res => {
        const posts = res.data;
        console.log(res.data)
        this.setState({ posts });
      })
      .catch(error => {

        console.log(error)
      })
  }

  render() {
    if (token === null) {
      window.location.replace("/Login");
    }
    return (

      <div>
        <div className="card" id="profilecard1">
          {this.state.posts.map(post =>
            <div className="card ">
              <div className="row">
                <div className="col-12">
                  <div className="card-body">
                    <div className="card-title mb-4">
                      <div className="d-flex justify-content-start">
                        <div className="userData ml-3">
                          <h2>Your Profile</h2>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="mt-4">
                          <div className="row">
                            <div className="col-sm-3 col-md-2 col-5">
                              <label className="item-label">Full Name</label>
                            </div>
                            <div className="col-md-8 col-6">{post.username}</div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-3 col-md-2 col-5">
                              <label className="item-label">Email</label>
                            </div>
                            <div className="col-md-8 col-6">{post.email}</div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-3 col-md-2 col-5">
                              <label className="item-label">Phone No.</label>
                            </div>
                            <div className="col-md-8 col-6">{post.contact}</div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-3 col-md-2 col-5">
                              <label className="item-label">Address</label>
                            </div>
                            <div className="col-md-8 col-6">{post.address}</div>
                          </div>
                          <hr />
                        </div>
                      </div>
                      <form className='LoginForm' onSubmit={this.onFormSubmit}>
                        <button className="btn btn-danger text-white mt-2" type='submit'>Sign Out</button>
                      </form>
                      <MyOrder />
                      <AllusersButton />
                      <Addproductbutton />
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <Chatbutton />
      </div>
    )
  }
}

